module.exports = __webpack_public_path__ + "img/AutoControl.98ea033c.jpg";